import { render, staticRenderFns } from "./PqDetails.vue?vue&type=template&id=b44964ac&scoped=true&"
import script from "./PqDetails.vue?vue&type=script&lang=js&"
export * from "./PqDetails.vue?vue&type=script&lang=js&"
import style0 from "./PqDetails.vue?vue&type=style&index=0&id=b44964ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44964ac",
  null
  
)

export default component.exports